<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th>Nome</th>
        <th>Cargo</th>
        <th>Nome de Usuário</th>
        <th>E-mail</th>
        <th>Admin</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>{{ user.name }}</td>
        <td>{{ user.roleName }}</td>
        <td>{{ user.nickname ? user.nickname : '-' }}</td>
        <td>{{ user.email ? user.email : '-' }}</td>
        <td class="text-uppercase">
          {{ user.isAdmin === '1' ? 'Sim' : 'Não' }}
        </td>
        <td class="text-center" v-html="statusTranslate(user.status)" />
        <td class="text-center">
          <router-link
            :to="`users/${user.id}`"
            class="btn btn-outline-primary btn-icon rounded-pill"
            title="Detalhes"
          >
            <i class="ph-file-text" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListUsers',

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListUsers',
        columnDefs: [
          {
            targets: [6],
            orderable: false,
            width: 100,
          },
        ],
      },
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
